/**
 * Rounds a number to an integer if it's whole, otherwise to 1 decimal place.
 * Ensures the return type is always a number.
 * @param value - The number (or string) to format.
 * @returns The formatted number as a number type.
 */
const roundToFixed = (value: number | string | null | undefined): number => {
  const parsedValue = typeof value === 'string' ? parseFloat(value) : value;

  if (typeof parsedValue !== 'number' || Number.isNaN(parsedValue)) {
    console.warn(`Invalid value passed to roundToFixed: ${value}`);
    return 0;
  }

  // Perform rounding
  return Number.isInteger(parsedValue) ? parsedValue : +parsedValue.toFixed(1);
};

export default roundToFixed;
